(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rzvni-entrega"] && !Shopify.designMode) return;
  try {
    (function () {
    var DAYS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
    var MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    var OFFSET = -5; /* Colombia, sin horario de verano */

    function nowCO() {
      var d = new Date();
      return new Date(d.getTime() + d.getTimezoneOffset() * 60000 + OFFSET * 3600000);
    }
    function iso(d) {
      return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
    }
    function fmt(d) { return DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()]; }
    function short(d) { return d.getDate() + ' ' + MONTHS[d.getMonth()]; }
    function range(a, b) {
      if (iso(a) === iso(b)) return fmt(a);
      if (a.getMonth() === b.getMonth()) return a.getDate() + ' – ' + short(b);
      return short(a) + ' – ' + short(b);
    }

    function init(el) {
      if (!el || el.dataset.ready) return;
      el.dataset.ready = '1';
      var holidays = (el.dataset.holidays || '').split(/[\s,;]+/).filter(Boolean);
      var sat = el.dataset.saturday === 'true';
      var cutoff = parseFloat(el.dataset.cutoff) || 14;
      var n = function (k) { return parseInt(el.dataset[k], 10) || 0; };

      function isWorkday(d) {
        var wd = d.getDay();
        if (wd === 0 || (wd === 6 && !sat)) return false;
        return holidays.indexOf(iso(d)) === -1;
      }
      function addWorkdays(d, count) {
        var r = new Date(d);
        while (!isWorkday(r)) r.setDate(r.getDate() + 1);
        for (var i = 0; i < count; i++) {
          r.setDate(r.getDate() + 1);
          while (!isWorkday(r)) r.setDate(r.getDate() + 1);
        }
        return r;
      }
      /* Próximo momento de corte (hoy si aún no pasa y es día hábil) */
      function nextCutoff(now) {
        var c = new Date(now);
        c.setHours(Math.floor(cutoff), Math.round((cutoff % 1) * 60), 0, 0);
        if (!isWorkday(c) || now >= c) {
          do { c.setDate(c.getDate() + 1); } while (!isWorkday(c));
        }
        return c;
      }

      var clock = el.querySelector('[data-eta-clock]');
      var shipEl = el.querySelector('[data-eta-ship]');
      var delEl = el.querySelector('[data-eta-deliver]');
      var orderEl = el.querySelector('[data-eta-order]');

      function paint() {
        var now = nowCO();
        var c = nextCutoff(now);
        var base = new Date(c); base.setHours(0, 0, 0, 0); /* día de despacho base */
        var zone = (el.querySelector('[data-eta-zone]:checked') || {}).value || 'a';
        var s1 = addWorkdays(base, n('shipMin'));
        var s2 = addWorkdays(base, n('shipMax'));
        var d1 = addWorkdays(s1, n(zone + 'Min'));
        var d2 = addWorkdays(s2, n(zone + 'Max'));
        if (shipEl) shipEl.textContent = range(s1, s2);
        if (delEl) delEl.textContent = range(d1, d2);
        if (orderEl) orderEl.textContent = 'Hoy';

        var diff = Math.max(0, c - now);
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (clock) clock.textContent = (h > 47 ? Math.floor(h / 24) + 'd ' + (h % 24) + 'h' : h + 'h ' + String(m).padStart(2, '0') + 'm ' + String(s).padStart(2, '0') + 's');
      }

      el.addEventListener('change', paint);
      paint();
      setInterval(paint, 1000);
    }

    function all(scope) { (scope || document).querySelectorAll('[data-eta]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); });
    else all();
    document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

})();
